import React, { useEffect, useState } from "react";
import { CardContent, Typography, Grid, CircularProgress } from "@mui/material";
import axiosInstance from "../../../utils/axiosInstance";

const Dashboard = () => {
    const [members, setMembers] = useState([]);
    const [instructors, setInstructors] = useState([]);
    const [guests, setGuests] = useState([]);
    const [challenges, setChallenges] = useState([]);
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);
    const [emojiCount, setEmojiCount] = useState(1);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true); // Set loading true at the beginning

            // Function to fetch data from a single endpoint
            const fetchDataFromApi = async (endpoint, setState, errorMessage) => {
                try {
                    const response = await axiosInstance.get(endpoint);
                    setState(response.data?.data || response.data?.instructors || response.data?.guests || []);
                } catch (error) {
                    const message = error.response?.data?.message || "An unexpected error occurred";
                    console.log(message);

                    if (message === errorMessage) {
                        setState([]);
                    } else {
                        // Optionally handle any unexpected errors
                        setState([]);
                    }
                }
            };

            // Fetch each endpoint individually
            await fetchDataFromApi(`membership/all`, setMembers, "No memberships found");
            await fetchDataFromApi(`instructors/all`, setInstructors, "No instructors found");
            await fetchDataFromApi(`guests/all`, setGuests, "No guests found");
            await fetchDataFromApi(`challenges/all`, setChallenges, "No challenges found");
            await fetchDataFromApi(`plans/all`, setPlans, "No plans found");

            setLoading(false); // Set loading false at the end
        };

        fetchData();
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setEmojiCount((prev) => (prev < 7 ? prev + 1 : 1));
        }, 500);

        return () => clearInterval(interval);
    }, []);

    const stats = [
        { name: "Members", count: members.length, color: "bg-blue-500" },
        { name: "Instructors", count: instructors.length, color: "bg-green-500" },
        { name: "Guests", count: guests.length, color: "bg-yellow-500" },
        { name: "Challenges", count: challenges.length, color: "bg-red-500" },
        { name: "Plans", count: plans.length, color: "bg-indigo-500" },
    ];

    return (
        <div className="p-4 text-blue-950">
            {/* Welcome Card */}
            <div className="mb-8 p-6 shadow-lg bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded">
                <Typography variant="h4" className="font-bold mb-2">
                    Welcome to Gym Management
                </Typography>
                <br />
                <Typography variant="subtitle1" className="flex items-center">
                    Manage your members, instructors, and guests all in one place.{" "}
                    <span className="ml-2 flex space-x-1">
                        {Array.from({ length: emojiCount }).map((_, index) => (
                            <span key={index} className="animate-bounce text-3xl">🏋🏿‍♀️</span>
                        ))}
                    </span>
                </Typography>
            </div>

            {/* Statistics Cards */}
            {loading ? (
                <div className="flex justify-center items-center min-h-[300px]">
                    <CircularProgress color="primary" />
                </div>
            ) : (
                <Grid container spacing={4}>
                    {stats.map((stat, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <div className={`p-6 shadow-md hover:shadow-lg transition-shadow rounded ${stat.color} text-white`}>
                                <CardContent>
                                    <Typography variant="h5" className="font-bold">
                                        {stat.name}
                                    </Typography>
                                    <Typography variant="h4" className="font-extrabold mt-2">
                                        {stat.count}
                                    </Typography>
                                </CardContent>
                            </div>
                        </Grid>
                    ))}
                </Grid>
            )}
        </div>
    );
};

export default Dashboard;
